const _ = require('underscore');

const actions = require('../_actions.js');

const initialState = {
	selected_type: "",
	selected_release: "",
	selected_name: "",
	is_fetching: false,
	is_updating: false,
	last_fetched_date: "",
	last_fetched_ago: "",
	last_updated: 0,
	list: {},
	options: [],
	initial_options: {},
	selected_options: {}
};

module.exports = function git(state, action) {
	if (typeof state === 'undefined') {
		return initialState;
	}
	switch (action.type) {
		case actions.SET_ENVIRONMENT:
			return _.assign({}, state, {
				initial_options: action.data.supported_options,
				selected_options: action.data.supported_options
			});
		case actions.NEW_DEPLOYMENT:
			return _.assign({}, state, {
				selected_type: "",
				selected_release: "",
				selected_name: "",
				selected_options: state.initial_options
			});
		case actions.SET_REVISION_TYPE:
			return _.assign({}, state, {
				selected_type: action.id,
				selected_release: "",
				selected_name: ""
			});
		case actions.TOGGLE_OPTION: {
			const selected_options = _.assign({}, state.selected_options);
			if (selected_options[action.name] === true) {
				selected_options[action.name] = false;
			} else {
				selected_options[action.name] = true;
			}
			return _.assign({}, state, {
				selected_options: selected_options
			});
		}
		case actions.SUCCEED_DEPLOYMENT_GET: {
			const deployment = action.data.data ? action.data.data.attributes : {};

			let {options} = deployment;
			if (typeof options !== 'undefined' && options.constructor === Array) {
				options = _.assign({}, deployment.options);
			}

			let release = deployment.sha;
			if (!deployment.sha) {
				release = deployment.package_link;
			}

			return _.assign({}, state, {
				selected_release: release,
				selected_type: deployment.ref_type,
				selected_name: deployment.ref_name,
				selected_options: options
			});
		}

		// SET_REVISION can in action.id take either a SHA1 or a SHA1 + "_" + name. The reason for the latter
		// is because if the selected_type has a list, e.g branches or tags, the `id` for each entry is a combination
		// of the sha1 and branch/tag name so that we can list all entries even if they have the same SHA1.
		case actions.SET_REVISION: {
			const newState = _.assign({}, state, {
				selected_release: action.id,
				selected_name: action.id
			});

			const gitRefs = state.list[state.selected_type] || [];
			// set the name from the promoted builds name
			if (gitRefs.promote_build && gitRefs.promote_build.attributes.ref_name) {
				newState.selected_release = action.id;
				newState.selected_name = gitRefs.promote_build.attributes.ref_name;
				return newState;
			}

			// matches a combined 40 char SHA1 + '_' + ref title (eg branch name)
			const combinedRef = /^([0-9a-f]{40})_(.*)/;
			if (combinedRef.test(action.id)) {
				const matches = combinedRef.exec(action.id);
				newState.selected_release = matches[1];
				newState.selected_name = matches[2];
				return newState;
			}

			return newState;
		}
		case actions.START_REPO_UPDATE:
			return _.assign({}, state, {
				is_updating: true,
				selected_type: "",
				selected_release: "",
				selected_name: "",
				error: null
			});

		case actions.SUCCEED_REPO_UPDATE:
			return _.assign({}, state, {
				is_updating: false,
				last_updated: action.received_at
			});

		case actions.FAIL_REPO_UPDATE:
			return _.assign({}, state, {
				is_updating: false,
				error: action.error.toString()
			});

		case actions.START_REVISIONS_GET:
			return _.assign({}, state, {
				is_fetching: true
			});

		case actions.SUCCEED_REVISIONS_GET: {
			let listAsArray = action.data.refs;

			// The backend returns a proper array if the 'key's are 0, 1, 2, 3
			// but an object if the 'keys' are 1, 2, 3.. this will ensure that
			// we only have to deal with an object.
			if (action.data.refs.constructor === Array) {
				listAsArray = _.assign({}, action.data.refs);
			}

			// we will need to manipulate the git 'types' that have a list of shas so they have an unique index
			_.each(listAsArray, function(refType) {
				if (typeof refType.list === 'undefined') {
					return;
				}

				// note: the mutation here is intentional
				refType.list = _.map(refType.list, function(item) { // eslint-disable-line no-param-reassign
					let title = item.title ? item.title : item.ref_name;

					// refs return the ref_name only, no title, the latter is for package deploy lists
					if (item.ref_name && !item.title) {
						const shortSha = item.id.substring(0, 7);
						title = title + " (" + shortSha + ") - " + item.ref_date + " (UTC +00:00)";
					}
					return {
						id: item.id + "_" + item.ref_name,
						ref_name: item.ref_name,
						sha: item.id,
						title: title
					};
				});
			});

			return _.assign({}, state, {
				is_fetching: false,
				list: listAsArray,
				options: action.data.options,
				last_fetched_date: action.data.last_fetched_date,
				last_fetched_ago: action.data.last_fetched_ago,
				last_updated: action.received_at
			});
		}
		case actions.FAIL_REVISIONS_GET:
			return _.assign({}, state, {
				is_fetching: false
			});

		default:
			return state;
	}
};
